import React from "react";
import {AssetDetailKvColgroupFour} from "./detailKvColgroup";

/**
 * KV 상세 테이블 — 열 비율 15% · 35% · 15% · 35% 고정.
 * 첫 행이 전체 너비(colspan=3)여도 colgroup으로 4열 구조를 유지한다.
 */
export function DetailKvTable({children, className = ""}) {
    return (
        <table className={`w-full asset-detail-kv-table ${className}`.trim()}>
            <AssetDetailKvColgroupFour />
            {children}
        </table>
    );
}
